/**
 * Column class
 * @private
 */
var Column = /** @class */ (function () {
    function Column() {
    }
    return Column;
}());
export { Column };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-excel-export/src/column.js
// module id = 571
// module chunks = 0